import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '../../../../constants';
import { ProductSectionFilters } from '../../product-section-filters.component';
import { typeListColumns } from './type-list.column';
import { useTypeList } from './type-list.hook';

export const TypeList = () => {
    const { data, isLoading, isError, error, isFetching, handleCreateType } =
        useTypeList();

    return (
        <SectionContainer isError={isError} isLoading={isLoading} error={error}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Products', href: Route.PRODUCTS },
                                { label: 'Types' },
                            ]}
                        />
                        <SectionTitle>Type List</SectionTitle>
                    </div>
                    <Button onClick={handleCreateType} type={'button'}>
                        Create New Type
                    </Button>
                </div>
                <ProductSectionFilters />
                <SectionDataTable
                    columns={typeListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

TypeList.displayName = 'TypeList';
